import { Component, ViewContainerRef } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { ClientService } from './shared/services/client.service';
import { ConfigService } from "./shared/utils/config.service";

import { AutoLogoutService } from './shared/services/auto-logout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  public title = '';
  client: any = {};
  subDomain: string = '';
  public constructor(private viewContainerRef: ViewContainerRef, private activatedRoute: ActivatedRoute
    , private router: Router, private titleService: Title, private clientService: ClientService, private configService: ConfigService,
    // Inject service
    private autoLogout: AutoLogoutService) {

    if (this.clientService.getClient() != null) {
      
      this.client = this.clientService.getClient();
      this.clientService.setClientProperties(this.client);
    }

  
  }
  ngOnInit() {
   
    //this.router
    //  .events
    //  .filter(event => event instanceof NavigationEnd)
    //  .map(() => {
    //    let child = this.activatedRoute.firstChild;
    //    while (child) {
    //      if (child.firstChild) {
    //        child = child.firstChild;
    //      } else if (child.snapshot.data && child.snapshot.data['pageTitle']) {
    //        return child.snapshot.data['pageTitle'];
    //      } else {
    //        return null;
    //      }
    //    }
    //    return null;
    //  }).subscribe((title: any) => {
    //    this.titleService.setTitle(title);
    //  });
  }
}
